import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { createClient } from '@supabase/supabase-js'

const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_ANON_KEY
)

export default function ResetPasswordPage() {
  const navigate = useNavigate()
  const [password, setPassword]   = useState('')
  const [password2, setPassword2] = useState('')
  const [loading, setLoading]     = useState(false)
  const [error, setError]         = useState(null)
  const [success, setSuccess]     = useState(false)
  const [ready, setReady]         = useState(false)

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event) => {
      if (event === 'PASSWORD_RECOVERY') setReady(true)
    })
    return () => subscription.unsubscribe()
  }, [])

  const canSubmit = password.length >= 6 && password === password2 && !loading

  async function handleSubmit(e) {
    e.preventDefault()
    if (password !== password2) { setError('Passwords do not match.'); return }
    setError(null)
    setLoading(true)
    try {
      const { error } = await supabase.auth.updateUser({ password })
      if (error) throw error
      setSuccess(true)
      setTimeout(() => navigate('/chat'), 2000)
    } catch (err) { setError(err.message) }
    finally { setLoading(false) }
  }

  return (
    <div className="auth-page">
      <div className="auth-card">

        <div className="auth-card-header">
          <div className="u-wordmark-on-dark">Hola<span>Sam</span></div>
        </div>

        <div className="auth-card-body">
          <h2 style={{ fontFamily: 'var(--font-serif)', fontSize: 'var(--text-2xl)', marginBottom: '0.5rem' }}>
            Set a new password
          </h2>

          {!ready && !success && (
            <p className="reset-verifying">Verifying your reset link…</p>
          )}

          {error   && <div className="alert-error"   style={{ marginTop: '1rem' }}>{error}</div>}
          {success && <div className="alert-success" style={{ marginTop: '1rem' }}>Password updated — redirecting…</div>}

          {ready && !success && (
            <form onSubmit={handleSubmit} style={{ marginTop: '1.5rem' }}>
              <div className="auth-field">
                <label className="u-form-label">New password</label>
                <input
                  type="password"
                  className="auth-input"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="At least 6 characters"
                  autoFocus
                />
              </div>
              <div className="auth-field">
                <label className="u-form-label">Confirm password</label>
                <input
                  type="password"
                  className="auth-input"
                  value={password2}
                  onChange={e => setPassword2(e.target.value)}
                  placeholder="Same password again"
                />
              </div>
              <button type="submit" className="auth-submit" disabled={!canSubmit}>
                {loading ? 'Saving…' : 'Set new password →'}
              </button>
            </form>
          )}
        </div>

      </div>
    </div>
  )
}